<template>
	<div class="wrapper">
		<parallax
			class="section page-header header-filter"
			:style="headerStyle"
		>
			<div class="container">
				<div class="md-layout">
					<div
						class="
							md-layout-item
							md-size-50
							md-small-size-70
							md-xsmall-size-100
						"
					>
						<h1 class="title">Praxis f&uuml;r Psychotherapie</h1>
						<h2>Amrei Schaal</h2>
						<br />
						<md-button
							href="javascript:void(0)"
							@click="scrollToElement('contact')"
							class="
								md-rose
								md-lg
								md-button
								md-primary
								md-round
								md-theme-default
							"
							>Nehmen Sie Kontakt mit mir auf</md-button
						>
					</div>
				</div>
			</div>
		</parallax>
		<div class="main main-raised">
			<div class="section">
				<div class="container">
					<div class="md-layout">
						<div
							class="
								md-layout-item md-size-66 md-xsmall-size-100
								mx-auto
								text-center
							"
						>
							<h2 class="title text-center">
								Willkommen auf der Homepage meiner Praxis
								f&uuml;r Psychotherapie.
							</h2>
							<h3 class="description">
								Hier finden Sie Informationen zu meiner Person
								und zur Praxis sowie zu Ablauf und Kosten einer
								Therapie.
							</h3>
							<h4>
								Die Therapie ist auch in englischer Sprache
								m&ouml;glich.
							</h4>
						</div>
					</div>
					<div class="features text-center">
						<div class="md-layout">
							<div
								class="
									md-layout-item
									md-medium-size-33
									md-small-size-100
								"
							>
								<a class="subtle-link" href="/ueber-mich">
									<div class="info">
										<div class="icon icon-info">
											<md-icon>fingerprint</md-icon>
										</div>
										<h4 class="info-title">
											&Uuml;ber mich
										</h4>
										<h5>
											Meine Intention ist es, Menschen in
											den verschiedensten Notlagen und
											Krisensituationen wertschätzend zu
											begleiten und in der gewünschten
											Entwicklung zu unterstützen.
										</h5>
										<h5>
											Mir ist es wichtig, Ihnen einen Raum
											zu geben, in dem Sie zur Ruhe kommen
											können und der einen Unterschied
											macht.
										</h5>
										<a href="/ueber-mich"
											>mehr erfahren...</a
										>
									</div>
								</a>
							</div>
							<div
								class="
									md-layout-item
									md-medium-size-33
									md-small-size-100
								"
							>
								<a class="subtle-link" href="/praxis">
									<div class="info">
										<div class="icon icon-success">
											<md-icon>verified_user</md-icon>
										</div>
										<h4 class="info-title">Arbeitsweise</h4>
										<h5>
											Ich arbeite klar und
											lösungsorientiert, mit einem
											intuitiven Blick fürs Wesentliche,
											für Besonderheiten und
											Veränderungsmöglichkeiten.
										</h5>
										<h5>
											Wissenschaftliche, aktuelle Techniken
											sind mir dabei genauso wichtig wie eine
											Offenheit in meiner Haltung und
											Zugewandtheit im Gespräch.
										</h5>
										<a href="/praxis">mehr erfahren...</a>
									</div>
								</a>
							</div>
							<div
								class="
									md-layout-item
									md-medium-size-33
									md-small-size-100
								"
							>
								<a class="subtle-link" href="/therapie">
									<div class="info">
										<div class="icon icon-rose">
											<md-icon>chat</md-icon>
										</div>
										<h4 class="info-title">Procedere</h4>
										<h4>
											Probleme und deren Bewältigung
											gehören zu unserem Alltag. Dauert
											die Belastung jedoch länger an oder
											wird die Lebensqualität und
											Alltagsbewältigung dauerhaft
											beeinträchtigt, kann sich eine
											psychische Erkrankung entwickeln.
										</h4>
										<h4>
											Dann kann eine Therapie helfen,
											Lösungswege zu finden.
										</h4>
										<a href="/therapie">mehr erfahren...</a>
									</div>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div id="contact" class="section section-contact">
				<contact />
			</div>
		</div>
	</div>
</template>

<script>
import Contact from "@/views/components/Contact";

export default {
	components: {
		Contact,
	},
	bodyClass: "landing-page",
	props: {
		profileImg1: {
			type: String,
			default: require("@/assets/img/faces/amrei_11_done_2.jpeg"),
		},
	},
	data() {
		return {
			images: [
				{
					url: require("@/assets/img/portugal_limes_sized.jpeg"),
				},
			],
		};
	},
	computed: {
		headerStyle() {
			const min = 0;
			const max = 0;
			let randomInt = Math.floor(Math.random() * (max - min + 1) + min);
			let url = this.images[randomInt].url;
			return {
				backgroundImage: `url(${url})`,
			};
		},
	},
	methods: {
		scrollToElement: function (element) {
			let element_id = document.getElementById(element);
			if (element_id) {
				element_id.scrollIntoView({
					block: "start",
					behavior: "smooth",
				});
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.md-card-actions.text-center {
	display: flex;
	justify-content: center !important;
}
.contact-form {
	margin-top: 30px;
}
.subtle-link,
.info {
	color: unset !important;
}
.md-has-textarea + .md-layout {
	margin-top: 15px;
}
.no-border-top {
	border-top: None !important;
}
</style>
